/**
 * 全站共用的指標配色。
 *
 * 抽出來的理由是它已經被各寫一份：WEEKEND_COLOR 在 OpsDashboard 與 PricingActionsTables
 * 各定義過一次同樣的 #cf1322。配色是語彙 —— 同一個顏色在不同畫面代表不同指標，
 * 比沒有顏色更糟，所以只能有一份。
 */

/** 住房率藍 / ADR 綠 / RevPAR 紫 / 營收橘。四個指標在圖表與表格一律用這組。 */
export const METRIC_COLOR = { occ: '#1890ff', adr: '#52c41a', revpar: '#722ed1', rev: '#fa8c16' };

/** 六日與假日的強調色。 */
export const WEEKEND_COLOR = '#cf1322';

/**
 * 在手房晚的團體/散客兩層 (前瞻圖堆疊柱)。
 *
 * 取 antd cyan-7 與 orange-7 而非 6 階：兩者對白色繪圖區都是 3.5:1，過 WCAG 1.4.11 的
 * 圖形物件 3:1 門檻 (原本的 #13c2c2 只有 2.21:1)。兩色亮度相同、僅以色相區分，
 * 但 CVD 色差 ΔE 15.9 (protan) 遠高於 8 的門檻，紅綠色弱仍分得開；堆疊柱另有
 * 間隙與數值標籤作為第二通道。
 */
export const SEGMENT_COLOR = { fit: '#08979c', group: '#d46b08' };

/**
 * 圖表上的中性圖元 (零軸線、中位參考線、「尚早」的柱、無語意的 icon)。
 *
 * 文字要 4.5:1、圖形物件只要 3:1 (WCAG 1.4.11)，所以這一支比 FAINT_COLOR 淡一階：
 * #8f8f8f 是 3.23:1，過門檻又不會搶走主資料的視覺重量。原本這些位置用的 #bfbfbf
 * 只有 1.84:1 —— 零軸線看不見的時候，一根貼近 0 的柱在上或在下就無從判斷。
 */
export const MARK_MUTED_COLOR = '#8f8f8f';

/**
 * 相對正常帶的訂房進度。顏色只是輔助 —— 超前/落後的亮度差僅 1.23:1，紅綠色弱分不出來，
 * 所以圖上一律另外標符號 (PACE_MARK)，顏色不可以是唯一通道。
 */
export const PACE_COLOR = { 超前: '#3f8600', 落後: '#cf1322', 尚早: MARK_MUTED_COLOR, 正常: '#13c2c2' };

/** 訂房進度的非顏色通道：與 PACE_COLOR 同 key，供圖上標在柱頂。 */
export const PACE_MARK = { 超前: '▲', 落後: '▼', 尚早: '·', 正常: '' };

/** 漲跌：綠升紅降，與台股慣例相反、與國際財報一致 —— 全站已統一採後者。 */
export const UP_COLOR = '#3f8600';
export const DOWN_COLOR = '#cf1322';

/**
 * 次要文字 (對比期、單位、附註)。
 *
 * 原本是 #8c8c8c，對白底只有 3.36:1，未達 WCAG 1.4.3 的內文 4.5:1。改成 #707070 後是 4.95:1，
 * 視覺上仍明顯比內文淡 —— 「次要」靠的是與內文的對比差，不是低到讀不出來。
 */
export const MUTED_COLOR = '#707070';

/**
 * 第三層文字 (口徑說明、圖表註腳、無資料的佔位符)。
 *
 * 取代散落各處的 #bfbfbf —— 那個值對白底只有 1.84:1，在一般螢幕與環境光下幾乎是白紙，
 * 而它承載的偏偏是「ADR/RevPAR 為純房租，TRevPAR 為含餐口徑」這種決定數字怎麼讀的說明。
 * #767676 是 4.54:1，剛過內文門檻。
 */
export const FAINT_COLOR = '#767676';


/** 風險提示的文字橘 (antd orange-8)：對白底 5.4:1，過內文 4.5:1；比 WEEKEND_COLOR 的紅更不會被讀成假日。 */
export const RISK_TEXT_COLOR = '#ad4e00';
